































import {Component, Prop, Vue} from 'vue-property-decorator'
import StepChainItem from './StepChainItem.vue'
import {IModalStepCommon} from '@/entities'

@Component({
  components: {
    StepChainItem
  }
})
export default class StepChain extends Vue {

  @Prop({
    validator(value: IModalStepCommon[]): boolean {
      return !!value?.length
    }
  }) readonly steps!: IModalStepCommon[]

  @Prop({ default: 0 }) readonly current!: number

  get innerSepClass(): Object {
    return {
      'many': this.stepsToShow.length > 4,
      'too-many': this.stepsToShow.length > 5
    }
  }

  get stepsToShow(): IModalStepCommon[] {
    return this.steps.filter((step: IModalStepCommon) => !step.silent);
  }

}
